import Types from '../../types';

const initialState = {
  error: null,
  firstRender: true,
  submitDisabled: true,
  waitingForResponse: true,
  showUnsubscribeNotification: false,
  email: {
    currentStatus: false,
    hasChanged: false,
    value: '',
  },
  directMail: {
    currentStatus: false,
    hasChanged: false,
    value: '',
  },
};

const getStatus = preference => {
  if (Object.keys(preference).length === 0) {
    return false;
  }

  return preference.status === 'ENABLED';
};

export default (state = initialState, action) => {
  switch (action.type) {
    case Types.GET_PREFERENCES_SUCCESS: {
      const { email, directMail } = action;

      return {
        ...state,
        waitingForResponse: false,
        email: {
          currentStatus: getStatus(email),
          hasChanged: false,
          value: email.address,
        },
        directMail: {
          currentStatus: getStatus(directMail),
          hasChanged: false,
          value: email.address,
        },
      };
    }
    case Types.UPDATE_PREFERENCES_SUCCESS: {
      return {
        ...state,
        waitingForResponse: false,
        submitDisabled: true,
        email: {
          ...state.email,
          hasChanged: false,
        },
        directMail: {
          ...state.directMail,
          hasChanged: false,
        },
      };
    }
    case Types.GET_PREFERENCES_ERROR: {
      return {
        ...state,
        error: { type: Types.GET_PREFERENCES_ERROR },
      };
    }
    case Types.UPDATE_PREFERENCES_ERROR: {
      return {
        ...state,
        error: { type: Types.UPDATE_PREFERENCES_ERROR },
      };
    }
    case Types.TOGGLE_CHECKBOX: {
      const { channel } = action;
      return {
        ...state,
        submitDisabled: false,
        [channel]: {
          ...state[channel],
          currentStatus: !state[channel].currentStatus,
          hasChanged: !state[channel].hasChanged,
        },
      };
    }
    case Types.WAITING_FOR_RESPONSE: {
      return { ...state, waitingForResponse: true, firstRender: false };
    }
    case Types.SHOW_UNSUB_NOTIFICATION: {
      return { ...state, showUnsubscribeNotification: true };
    }
    case Types.HIDE_UNSUB_NOTIFICATION: {
      return { ...state, showUnsubscribeNotification: false };
    }
    default: {
      return state;
    }
  }
};
